import OspreyApiHelper from './helper'

export default class OspreyMe {

    static get(path) {
        return OspreyApiHelper.genericGet(path)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-me.js